module.exports = __webpack_public_path__ + "downRightArrow.png?f2ad38138dc9852e993705970ec6dde7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/downRightArrow.png
// module id = 45
// module chunks = 0